import { Entry } from 'contentful';

import { TypeSpeciesSkeleton } from '@generated/contentful';

interface IProps {
  speciesList?: Entry<TypeSpeciesSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
  speciesId?: string;
}

export const getOrderedSpeciesList = ({
  speciesList,
  speciesId,
}: IProps): Entry<TypeSpeciesSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[] | undefined => {
  if (!speciesList) {
    return undefined;
  }
  if (!speciesId) {
    return speciesList;
  }
  const filteredList = speciesList.filter(sp => sp.fields.externalId !== speciesId);
  const selectedSpecies = speciesList.find(sp => sp.fields.externalId === speciesId);
  if (!selectedSpecies) {
    return speciesList;
  }
  filteredList.unshift(selectedSpecies);

  return filteredList;
};
